import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main className="min-h-screen bg-gray-50 px-4 py-24 text-center" data-testid="not-found-page">
      <p className="text-sm font-semibold text-red-600">404</p>
      <h1 className="mt-3 text-4xl sm:text-5xl font-bold text-gray-950">Page not found</h1>
      <p className="mx-auto mt-4 max-w-lg text-gray-600">
        The page you requested does not exist or is no longer available.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex bg-gray-950 px-5 py-3 font-semibold text-white transition-colors hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-700 focus:ring-offset-2"
        data-testid="not-found-home-link"
      >
        Return to Helply
      </Link>
    </main>
  );
}